import { z } from 'zod';

import { DrawId, LosId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableDraw = z
  .object({
    id: DrawId,
    loanId: LosId,

    amount: z.number(),
    date: zodTemporalPlainDate,
    comment: z.string().optional(),
    isReversal: z.boolean().optional(),
    transactionId: DrawId.optional(),
    externalId: z.string().optional(),
    createdAt: zodTemporalInstant.optional(),
  })
  .meta({ title: 'Draw' });

export type ExportableDraw = z.infer<typeof ExportableDraw>;
